import { Component, computed, input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [ NgStyle],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  host: {
    class: 'w-full h-full relative inline-flex items-center justify-center overflow-hidden bg-sky-100 rounded-full',
  },
})
export class AvatarComponent {
  url = input.required<string | null>();
  name = input.required<string>();

  initials = computed(() => {
    const name = this.name()?.trim();
    if (!name) return '??';

    const words = name.split(' ').filter(w => w.length > 0);

    if (words.length > 1) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }

    return words[0][0]?.toUpperCase() ?? '??';
  });

  backgroundColor = computed(() => {
    let hash = 0;
    for (let i = 0; i < this.initials().length; i++) {
      hash = this.initials().charCodeAt(i) + ((hash << 5) - hash);
    }
    const color = `hsl(${hash % 360}, 50%, 60%)`;
    return color;
  });
}
